import 'index.css';
import {PRODUCTS_GRID_ROOT_ELEMENT_ID} from 'lib/constants';
import ProductsGridApp from 'modules/ProductsGrid/App';
import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';

export const productsGridRootElement = document.getElementById(
    PRODUCTS_GRID_ROOT_ELEMENT_ID,
);

if (productsGridRootElement) {
    const root = ReactDOM.createRoot(productsGridRootElement);
    root.render(
        <React.StrictMode>
            <div className="ReactModule_Container">
                <ProductsGridApp />
            </div>
        </React.StrictMode>,
    );
}
